import { Page, PageSkeleton } from '@/components';
import { useApi } from '@/api';
import { useSearchParams } from '@/hooks';
import { useParams } from 'react-router';
import { Flex, KpiCard, KpiSkeleton, ChartSkeleton } from '@blockanalitica/ui';
import { useNetwork } from '@/hooks';
import LiquidationsTable from './LiquidationsTable';
import CollateralSeizedHistoricTabs from './CollateralSeizedHistoricTabs';
import LatestCollateralBuyers from './LatestCollateralBuyers';

type LiquidationsResponse = {
  liquidation_count: string | null;
  collateral_amount_usd: string | null;
  debt_amount_usd: string | null;
  liquidation_penalty: string | null;
  underlying_symbol: string | null;
  underlying_address: string | null;
};

export default function MarketPage() {
  const network = useNetwork() as string;
  const { marketAddress } = useParams() as { marketAddress: string };
  const [daysAgo] = useSearchParams('days_ago', '1');

  const [data, error] = useApi<LiquidationsResponse>({
    url: `/markets/${marketAddress}/liquidations/stats/`,
    queryParams: {
      days_ago: daysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return (
      <PageSkeleton>
        <Flex gap={['s', 'xs']} flexDirection={['column', 'row']}>
          <KpiSkeleton />
          <KpiSkeleton />
          <KpiSkeleton />
          <KpiSkeleton />
        </Flex>
        <ChartSkeleton />
      </PageSkeleton>
    );
  }
  return (
    <Page title="Liquidations">
      <Flex gap={['s', 'xs']} flexDirection={['column', 'row']}>
        <KpiCard
          title="# of Liquidations"
          data={data}
          field="liquidation_count"
        />
        <KpiCard
          title="Collateral Sezed"
          data={data}
          field="collateral_amount_usd"
          options={{
            valueOptions: {
              currencyValueOptions: {
                currency: 'USD',
                notation: 'compact'
              }
            }
          }}
        />
        <KpiCard
          title="Debt Repaid"
          data={data}
          field="debt_amount_usd"
          options={{
            valueOptions: {
              currencyValueOptions: {
                currency: 'USD',
                notation: 'compact'
              }
            }
          }}
        />
        <KpiCard
          title="Liquidation Penalty"
          data={data}
          field="liquidation_penalty"
          options={{
            valueOptions: {
              currencyValueOptions: {
                currency: 'USD',
                notation: 'compact'
              }
            }
          }}
        />
      </Flex>
      <CollateralSeizedHistoricTabs marketAddress={marketAddress} />
      <LiquidationsTable marketAddress={marketAddress} network={network} />
      <LatestCollateralBuyers marketAddress={marketAddress} network={network} />
    </Page>
  );
}
